// extracted by mini-css-extract-plugin
export default {"skeleton":"LoadingSkeleton_skeleton__jYz4g","shimmer":"LoadingSkeleton_shimmer__gIE+M"};